import ReactToPrint, { useReactToPrint } from 'react-to-print';
import { FormattedMessage } from 'react-intl';
import { Button, message } from 'antd';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { USE_SERVER_LABEL } from '../../Constants';
import { API } from '../../AxiosWrapper';

const PrintWrap = forwardRef((props, ref) => (
  <div ref={ref} className="sheet">
    <div className={props.bodyClass}>
      {props.children}
    </div>
  </div>
))

const ensureHeadStyle = (css) => {
  if (!css) return;
  const id = 'server-label-css';
  let styleEl = document.getElementById(id);
  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = id;
    styleEl.type = 'text/css';
    document.head.appendChild(styleEl);
  }
  styleEl.textContent = css;
}

const extractCssAndMarkup = (html) => {
  const match = html.match(/<style[^>]*>([\s\S]*?)<\/style>/i);
  const css = match ? match[1] : '';
  const markup = match ? html.replace(match[0], '') : html;
  return { css, markup };
}

const PrintButton = ({ children, businessKey }) => {
  const componentRef = useRef(null);
  const bodyClass = 'zlabel';

  const [labelHtml, setLabelHtml] = useState('');
  const [shouldPrint, setShouldPrint] = useState(false);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    removeAfterPrint: false,
  });

  useEffect(() => {
    if (shouldPrint && (USE_SERVER_LABEL ? !!labelHtml : true)) {
      handlePrint();
      setShouldPrint(false);
    }
  }, [shouldPrint, labelHtml, handlePrint]);

  const fetchAndPrint = () => {
    if (!businessKey) return;
    if (!labelHtml) {
      API.GET(`label/${businessKey}`)
        .then((res) => {
          if (typeof res.data !== 'string') {
            message.error('Label response invalid');
            return;
          }
          const { css, markup } = extractCssAndMarkup(res.data);
          ensureHeadStyle(css);
          setLabelHtml(markup);
          setShouldPrint(true);
        })
        .catch(() => message.error('Label fetch failed'));
    } else {
      setShouldPrint(true);
    }
  };

  if (USE_SERVER_LABEL) {
    return (
      <>
        <Button onClick={fetchAndPrint}>
          <FormattedMessage id="AboutDelivery.PrintLabel" />
        </Button>
        <div style={{ display: 'none' }}>
          <div ref={componentRef} dangerouslySetInnerHTML={{ __html: labelHtml }} />
        </div>
      </>
    );
  }

  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Button>
            <FormattedMessage id="AboutDelivery.PrintLabel" />
          </Button>
        )}
        content={() => componentRef.current}
        bodyClass={bodyClass}
      />
      <div style={{ display: 'none' }}>
        <PrintWrap bodyClass={bodyClass} ref={componentRef}>
          {children}
        </PrintWrap>
      </div>
    </>
  );
}

export default PrintButton;
